var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from 'styled-components';
import { colors, devices } from '../../../base/styled/variables.styled';
import { typography } from "../../../base/styled/typography.style";
export const MenuListContainer = styled.div `
  position: relative;
  display: inline-block;

	@media ${devices.desktop} {
    max-width: 232px;
  }

	@media ${devices.mobile} {
    max-width: 100%;
  }
`;
const bodyStyles3 = __rest(typography.body3, []);
const bodyStyles2 = __rest(typography.body2, []);
const bodyStyles2Highlight = __rest(typography.body2Highlight, []);
export const UserTrigger = styled.button.withConfig({
    shouldForwardProp: (prop) => !['inverse', '$inverse'].includes(prop),
}) `
	${bodyStyles3}
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};

	@media ${devices.desktop} {
    max-width: 232px;
  }

	@media ${devices.mobile} {
    max-width: 100%;
  }

	.ps-user-full-name {
		flex: 1;
		min-width: 0;
		color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};
		@media ${devices.desktop}, ${devices.mobile} {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}

	.ps-user-avatar{
		width: 40px;
		height: 40px;
		min-width: 40px;
		max-width: 40px;
		flex-shrink: 0;
	}

  &:hover {
    background: ${({ $inverse }) => $inverse ? colors.brand800 : colors.brand75};
  }

  &.active {
    background: ${({ $inverse }) => $inverse ? colors.brand800 : colors.brand75};
		color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.brand500};
		
		.ps-user-full-name {
			color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.brand500};
		}
  }

  &:focus-visible {
    outline: 3px solid ${({ $inverse }) => $inverse ? colors.neutral000 : colors.brand300};
    background: ${({ $inverse }) => $inverse ? colors.brand800 : colors.brand75};
  }
`;
export const DropdownIcon = styled.span.withConfig({
    shouldForwardProp: (prop) => !['inverse', '$inverse'].includes(prop),
}) `
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral600};

  svg {
    width: 16px;
    height: 16px;
  }

  &.active {
    transform: rotate(90deg);
		color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.brand500};

		@media ${devices.tablets} {
			transform: rotate(-90deg);
		}
  }
`;
export const UserInfo = styled.div `
  display: flex;
  justify-content: ${props => props.$fullScreen ? 'flex-start' : 'space-between'};
  align-items: ${props => props.$fullScreen ? 'center' : 'flex-start'};
  padding: 16px;
  ${bodyStyles2}
  flex-direction: row;
  gap: ${props => props.$fullScreen ? '8px' : '0'};

  .user-content {
    flex: 1;
    order: ${props => props.$fullScreen ? 2 : 1};
  }

  .user-name {
    ${bodyStyles2Highlight}
    margin-bottom: 4px;
  }

  .user-email {
    ${bodyStyles3}
    color: ${colors.neutral600};
  }

  .close-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s ease;
    order: ${props => props.$fullScreen ? 1 : 2};
    flex-shrink: 0;

    &:hover {
      opacity: 0.7;
    }

    &:focus-visible {
      outline: 2px solid ${colors.brand500};
      outline-offset: 2px;
      border-radius: 4px;
    }

    svg {
      width: ${props => props.$fullScreen ? '16px' : '14px'};
      height: ${props => props.$fullScreen ? '16px' : '14px'};
    }
  }
`;
export const DropdownMenu = styled.div `
	${bodyStyles2}
  position: absolute;
  top: 100%;
  right: 0;
  width: 320px;
  background: ${colors.neutral000};
  border: 1px solid transparent;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-8px);
  transition: all 0.2s ease;
  overflow: hidden;

	@media ${devices.tablets} {
    box-shadow: 0px -6px 14px -6px #005EB833;
  }

  &.active {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  ${props => props.$fullScreen && `
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    top: auto !important;
    width: 100% !important;
    box-shadow: unset !important;
    transform: translateY(100%) !important;
    transition: transform 0.3s ease-in-out !important;
    height: calc(100vh - 84px) !important;
    opacity: 1 !important;
    visibility: visible !important;
    z-index: 1000 !important;

    &.active {
      transform: translateY(0) !important;
    }
  `}

  ul {
    list-style: none;
    margin: 0;
    padding: ${props => props.$fullScreen ? '0 25px' : '0'};
    ${props => props.$fullScreen && 'flex: 1; overflow-y: auto;'}

    li {
      &.separator {
        height: 1px;
        background: ${colors.neutral200};
        margin: 8px 0;
      }

      &.menu-item {
				margin-bottom: 4px;

				&:last-child {
					margin-bottom: 0;
				}

				.menu-button {
					width: 100%;
				}

        .menu-link,
        .menu-button {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: ${props => props.$fullScreen ? '8px' : '8px 16px'};
          color: ${colors.neutral800};
          text-decoration: none;
          ${bodyStyles2};
          transition: background-color 0.2s ease;
          background: transparent;
          border: none;
          text-align: left;
          cursor: pointer;
          border-radius: 4px;

          &:hover {
            background: ${colors.brand75};
          }

          .menu-item-title {
            ${bodyStyles2};
            margin: 0;
          }
        }
      }
    }
  }

  @media ${devices.tablets} {
    ${props => !props.$fullScreen && `
      position: fixed;
      top: auto;
      bottom: 0;
      left: 0;
      right: 0;
      padding-bottom: 16px;
      width: 100%;
      border-radius: 16px 16px 0 0;
      transform: translateY(100%);

      &.active {
        transform: translateY(0);
      }
    `}
  }
`;
//# sourceMappingURL=MenuList.style.js.map